import { LayoutDashboardIcon } from "lucide-react";
import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { msg } from "#/utils/i18n";
import { useAuthContext } from "#/contexts/AuthContext";
import { Card, CardContent } from "#/components/atoms/card";
import { PageContainer } from "#/components/atoms/page-container";
import { PageHeader } from "#/components/molecules/page-header";

export const Route = createFileRoute("/$tenantCode/$market/")({
  beforeLoad: () => ({ getTitle: () => m["dashboard.title"]() }),
  component: Dashboard,
});

function Dashboard() {
  const keycloak = useAuthContext();
  const tokenParsed = keycloak.tokenParsed as
    | { given_name?: string; family_name?: string }
    | undefined;
  const firstName = tokenParsed?.given_name ?? "";
  const name = firstName !== "" ? firstName : "User";

  return (
    <PageContainer className="space-y-4">
      <PageHeader
        title={msg(m["dashboard.title"])}
        icon={LayoutDashboardIcon}
      />
      <Card className="p-4">
        <CardContent>
          <p>{m["dashboard.welcome"]({ name })}</p>
          <p className="mt-2 text-muted-foreground">
            {m["dashboard.description"]()}
          </p>
        </CardContent>
      </Card>
    </PageContainer>
  );
}
